import React from "react";

import { Icon } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

import AibleStep from "containers/CreateWizard/AibleStep";

import IndeterminateCheckBox from "components/CreateWizard/Dataset/IndeterminateCheckBox";

import styles from "./style.module.css";
import Tooltip from "components/Inputs/Tooltip";

import { HIGH_CORRELATION_CUTOFF } from "containers/Setup/reducer";

export default class Correlation extends React.PureComponent {
  render() {
    const { id, isShow, options, outcome, ignored, updateIgnored, correlations, isDataMode } = this.props;

    const hasProblematicPredictors = correlations && correlations.length > 0;

    return (
      <div className={styles.correlationWrapper}>
        <AibleStep
          id={id}
          bId={"correlations"}
          message={"Problematic Predictors " + (hasProblematicPredictors ? "Detected" : "Evaluated")}
          secondaryMessage={
            hasProblematicPredictors
              ? "The following columns are very good predictors of " +
                (outcome ? outcome : "the outcome") +
                ". " +
                "(Maybe a little too good...) Would your AI have access to this information at the " +
                "time of making a prediction? If not, you should remove it because otherwise " +
                "you are expecting your AI to time-travel." +
                "If they are mathematically related (such as calculated fields), you should also remove them"
              : ""
          }
          isBreak={true}
        />
        <div style={{ padding: "0px 20px" }}>
          <div className={styles.selectSubheader + " " + styles.sBold} style={{ marginBottom: "10px" }}>
            {hasProblematicPredictors ? "Select the columns to exclude" : "No problematic predictors found."}
          </div>
          <div className={styles.predictorsList}>
            {hasProblematicPredictors
              ? correlations.map((field) => (
                  <ProblematicPredictor
                    key={field.label}
                    predictor={field}
                    updateIgnored={updateIgnored}
                    isIgnored={ignored && ignored[field.label]}
                    isLocked={isDataMode || (options && options["lock"])}
                  />
                ))
              : ""}
          </div>
        </div>
      </div>
    );
  }
}

export class ProblematicPredictor extends React.PureComponent {
  render() {
    const {
      labelOne,
      labelTwo,
      predictor,
      updateIgnored,
      isIgnored,
      isLocked,
      barColor,
      style,
      color,
      noTitle,
      hasCheckbox,
      isSense,
      selectAll,
      isAllSelected,
      isLabel,
      showSelectAll
    } = this.props;

    return (
      <div
        className={styles.problematicPredictorWrapper}
        title={predictor && (predictor.correlationLabel ? predictor.correlationLabel : predictor.label)}
        style={{ ...style }}
      >
        {isLocked ? (
          ""
        ) : (
          <div className={styles.checkbox} style={{ opacity: labelOne && labelTwo ? 0 : undefined }}>
            <IndeterminateCheckBox
              checked={isIgnored ? true : false}
              onChange={
                isLocked || (labelOne && labelTwo) ? () => {} : () => updateIgnored(predictor.label, !isIgnored)
              }
              indeterminate={isIgnored === "SOME" ? true : undefined}
              style={{ cursor: labelTwo ? "default" : undefined, marginTop: "0px" }}
              disabled={isLocked || (labelOne && labelTwo)}
            />
          </div>
        )}
        {showSelectAll && selectAll && (
          <Tooltip trigger={["hover"]} overlay={"Select All"}>
            <div className={styles.checkbox}>
              <input
                type="checkbox"
                checked={isAllSelected}
                style={{ marginTop: "0px", marginRight: "6px", cursor: "pointer" }}
                onClick={() => selectAll()}
              />
            </div>
          </Tooltip>
        )}
        <ProblematicPredictorLabel
          noMargin={isLocked}
          noIgnore
          style={{ opacity: isIgnored === true ? 0.3 : 1 }}
          onClick={isLocked || (labelOne && labelTwo) ? () => {} : () => updateIgnored(predictor.label, !isIgnored)}
          label={labelOne || (predictor.correlationLabel ? predictor.correlationLabel : predictor.label)}
          noTitle={noTitle}
          isSense={isSense}
          selectAll={selectAll}
        />
        {labelTwo ? (
          <React.Fragment>
            {hasCheckbox ? (
              <div className={styles.checkbox} style={{ opacity: 0 }}>
                <input type="checkbox" checked={false} style={{ cursor: "default", marginTop: "0px" }} disabled />
              </div>
            ) : (
              ""
            )}
            <ProblematicPredictorLabel
              noIgnore
              style={{ opacity: isIgnored ? 0.3 : 1, marginLeft: hasCheckbox ? "10px" : "0px" }}
              label={labelTwo || (predictor.correlationLabel ? predictor.correlationLabel : predictor.label)}
              isSense={isSense}
            />
          </React.Fragment>
        ) : (
          <ProblematicPredictorBar
            style={{ opacity: isIgnored ? 0.3 : 1 }}
            value={predictor.correlation}
            color={color}
            barColor={barColor}
            isSense={isSense}
          />
        )}
      </div>
    );
  }
}

export class ProblematicPredictorLabel extends React.PureComponent {
  render() {
    const { label, className, noMargin, noIgnore, style, warning, info, noTitle, maxWidth, isSense, ...retProps } =
      this.props;
    const retMaxWidth = isSense ? 205 : isNaN(maxWidth) ? 175 : maxWidth;
    return (
      <div
        {...retProps}
        className={
          styles.problematicPredictorLabel + " " + (isSense ? styles.isSense : "") + " " + (className ? className : "")
        }
        style={{
          margin: noMargin ? "0px 10px 0px 0px" : undefined,
          width: retMaxWidth,
          flexBasis: retMaxWidth ? retMaxWidth : undefined,
          ...style
        }}
      >
        <div
          className={styles.problematicPredictorLabelSpan}
          style={{ maxWidth: retMaxWidth - (warning ? 18 : 0) - (info ? 24 : 0) }}
        >
          <OverlayTrigger
            placement={"top"}
            trigger={noTitle ? [] : ["hover"]}
            rootClose
            overlay={<Popover>{label}</Popover>}
          >
            <span>
              {noIgnore ? "" : <span style={{ marginRight: "4px" }}>{"Exclude"}</span>}
              {label}
            </span>
          </OverlayTrigger>
        </div>
        {info ? (
          <OverlayTrigger
            placement={"top"}
            trigger={["click"]}
            rootClose
            overlay={<Popover id="popover-positioned-top">{info}</Popover>}
          >
            <FontAwesomeIcon icon={faInfo} className={styles.typeIcon} style={{ marginLeft: "6px" }} />
          </OverlayTrigger>
        ) : (
          ""
        )}
        {warning ? (
          <OverlayTrigger
            placement={"top"}
            trigger={["click"]}
            rootClose
            overlay={<Popover id="popover-positioned-top">{warning}</Popover>}
          >
            <div style={{ marginLeft: "auto", paddingLeft: "6px", cursor: "pointer" }}>
              <Icon type="warning" size={16} />
            </div>
          </OverlayTrigger>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export class ProblematicPredictorBar extends React.PureComponent {
  render() {
    const { value, color, barColor, className, isScore, isSense, ...retProps } = this.props;
    let valueLabel = "0.0";

    if (isScore) {
      valueLabel = (value * 10).toFixed(1);

      if (valueLabel == "0.0" && value > 0) {
        valueLabel = "<0.1";
      }
    } else {
      valueLabel = (value * 100).toFixed(2);

      if (valueLabel == "0.00" && value > 0) {
        valueLabel = "<0.01";
      }
    }

    if (value >= HIGH_CORRELATION_CUTOFF) {
      valueLabel = "HIGH";
    }

    return (
      <div
        {...retProps}
        className={
          styles.problematicPredictorBar + " " + (isSense ? styles.isSense : "") + " " + (className ? className : "")
        }
      >
        <div
          className={styles.problematicPredictorBarFill + " " + (isSense ? styles.isSense : "")}
          style={{ width: Math.min(100, value * 100) + "%", background: barColor }}
        >
          <span
            className={styles.problematicPredictorBarLabel + " " + (isSense ? styles.isSense : "")}
            style={{ color: color }}
          >
            {valueLabel}
          </span>
        </div>
      </div>
    );
  }
}
